import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Text, Icon } from '@theneatcompany/nui'
import { FormattedMessage } from 'react-intl'

import Card from '@/components/common/Card/Card'
import Link from '@/components/common/Link'
import { URLS } from '@/constants'
import CheckboxField from '@/components/Forms/CheckboxField'

import styles from './ModularizedPlanCard.module.scss'

const getLearnMoreLink = key => ({
  vip: URLS.vipService,
  automated_insights: URLS.automatedInsights,
}[key])

export default function ModularizedPlanCard({
  module: {
    name, type, price, description, features,
  },
  onChange,
  hasAdditionalSolutions,
}) {
  const isBase = type === 'base'
  const handleChange = (e) => {
    e.persist()
    onChange(p => (e.target.checked ? p + price : p - price))
  }

  const planContent = (
    <>
      <Text color="foreground-primary" type="display" size="small" typeStyle="bold">{name}</Text>
      <Text color="tint-brand-primary" type="display" size="small" typeStyle="bold">
        <FormattedMessage id="byYear" values={{ hasPlus: isBase ? 0 : 1, price }} />
      </Text>
    </>
  )

  return (
    <Fragment key={type}>
      <Card className={isBase && styles.disabled}>
        <Card.Body className={styles.body}>
          <div>
            <CheckboxField
              inputProps={{ disabled: isBase }}
              labelProps={{ label: planContent }}
              name={type}
              onChange={handleChange}
            />

            <Text color="foreground-secondary" element="p">{description} {isBase && '(required)'}</Text>
            {!isBase && (
              <>
                <Link to={getLearnMoreLink(type)} external openTab size="small">
                  <FormattedMessage id="learnMore" values={{ name }} />
                </Link>
              </>
            )}
          </div>
          <div>

            <ul className={styles.featuresList}>
              {features.slice().map(feature => (
                <li key={feature.description} className={styles.featuresElement}>
                  <Icon name="check" fill="primary" />
                  <Text size="small">{feature.description}</Text>
                </li>
              ))}
            </ul>

          </div>
        </Card.Body>
      </Card>

      {(isBase && hasAdditionalSolutions) && (
        <div className={styles.additionalSolutions}>
          <Text color="foreground-secondary">
            <FormattedMessage id="additionalSolutions" />
          </Text>
        </div>
      )}
    </Fragment>
  )
}

ModularizedPlanCard.propTypes = {
  module: PropTypes.shape({
    name: PropTypes.string,
    type: PropTypes.string,
    price: PropTypes.number,
    description: PropTypes.string,
    enabled: PropTypes.bool,
    features: PropTypes.arrayOf(PropTypes.shape({
      description: PropTypes.string,
    })),
  }),
  onChange: PropTypes.func,
  hasAdditionalSolutions: PropTypes.bool,
}
